import m from "../../geodata/es2015/germanyLow";
window.am4geodata_germanyLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/germanyLow.js
// module id = null
// module chunks = 